import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHappy = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm3.738 7.315a.75.75 0 0 1 .386.988 4.5 4.5 0 0 1-8.248 0A.75.75 0 1 1 5.25 9.2a3 3 0 0 0 5.5 0 .75.75 0 0 1 .988-.386zM4.5 5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
    </g>
  );
};

export default withIcon(IconHappy);
